/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useSimpliCity } from "@simplicitycms/simplicity-common";

/**
 * @param {string} featureName
 */
const useHasModelFeature = (featureName) => {

    let hasFeature = false;
    const { model, hasModelFeature } = useSimpliCity();
    if (!featureName) {
        return false;
    }
    const features = model?.features;
    if (hasModelFeature(featureName)) {
        hasFeature = features[featureName];
    }
    return hasFeature;
};

export { useHasModelFeature };
